"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var router_1 = require("@angular/router");
var shared_1 = require("@logbook/shared");
var state_storage_service_1 = require("@logbook/core/auth/services/state-storage.service");
var mixpanel_service_1 = require("@logbook/core/tracking/mixpanel.service");
var mixpanel_event_enum_1 = require("@logbook/core/tracking/mixpanel-event.enum");
var login_service_1 = require("@logbook/core/auth/services/login.service");
var LoginComponent = /** @class */ (function () {
    function LoginComponent(loginService, router, route, stateStorageService, mixpanelService) {
        this.loginService = loginService;
        this.router = router;
        this.route = route;
        this.stateStorageService = stateStorageService;
        this.mixpanelService = mixpanelService;
        this.authenticationLogoutDelay = null;
    }
    LoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loginService.logout();
        if (this.route.snapshot.queryParams) {
            this.authenticationLogout = this.route.snapshot.queryParams["logout"];
            this.authenticationLogoutDelay = rxjs_1.of(true).pipe(operators_1.delay(1500))
                .subscribe(function () { return _this.authenticationLogout = false; });
            if (this.authenticationLogout) {
                this.mixpanelService.reset();
            }
        }
        var required = forms_1.Validators.required;
        this.loginForm = new forms_1.FormGroup({
            email: new forms_1.FormControl(null, [
                required
            ]),
            password: new forms_1.FormControl(null, [
                required
            ]),
            rememberMe: new forms_1.FormControl(false)
        });
    };
    LoginComponent.prototype.ngOnDestroy = function () {
        if (this.authenticationLogoutDelay) {
            this.authenticationLogoutDelay.unsubscribe();
        }
    };
    LoginComponent.prototype.login = function () {
        var _this = this;
        if (this.loginForm.valid) {
            this.loginForm.markAsPending();
            this.loginService.login({
                username: this.email.value,
                password: this.password.value,
                rememberMe: this.rememberMe.value
            }).then(function () {
                var redirect = _this.stateStorageService.getUrl();
                _this.mixpanelService.identify(_this.email.value);
                _this.mixpanelService.track(mixpanel_event_enum_1.MixpanelEvent.LOG_IN, {
                    username: _this.email.value,
                    rememberMe: _this.rememberMe.value
                });
                if (redirect) {
                    _this.router.navigateByUrl(redirect);
                }
                else {
                    _this.router.navigate(["/logs"]);
                }
            }).catch(function (reason) {
                var causeFailed;
                _this.loginForm.updateValueAndValidity();
                if (reason.status && reason.status === 401) {
                    var body = reason.error;
                    if (body.AuthenticationException && (body.AuthenticationException === 'Le compte utilisateur est désactivé'
                        || body.AuthenticationException === "L'utilisateur n'appartient à aucune team")) {
                        _this.authenticationError = "<div>Your account needs to be activated.</div>" +
                            "<div> Please contact teamlogs support at <b>contact@teamlogs.net</b></div>";
                    }
                    else {
                        _this.authenticationError = "Bad password or username";
                    }
                }
                else {
                    causeFailed = "Erreur interne";
                    _this.authenticationError = "There is a problem please try again later";
                }
                _this.mixpanelService.track(mixpanel_event_enum_1.MixpanelEvent.LOG_IN_FAILED, {
                    username: _this.email.value,
                    cause: causeFailed
                });
            });
        }
        else {
            shared_1.validateAllFormFields(this.loginForm);
        }
    };
    Object.defineProperty(LoginComponent.prototype, "email", {
        get: function () {
            return this.loginForm.get('email');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginComponent.prototype, "password", {
        get: function () {
            return this.loginForm.get('password');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginComponent.prototype, "rememberMe", {
        get: function () {
            return this.loginForm.get('rememberMe');
        },
        enumerable: true,
        configurable: true
    });
    return LoginComponent;
}());
exports.LoginComponent = LoginComponent;
